module.exports = __webpack_public_path__ + "89b0877eac845a33076f7132e5344a52.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201605_Presse_AVANGA_Sputnika_2_388KB.jpg
// module id = 568
// module chunks = 0